<template>
  <div class="user-list">
    <h3>沟通记录</h3>
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item label="用户1">
        <el-input placeholder="输入用户id" v-model.number="filter.senderId"></el-input>
      </el-form-item>
      <el-form-item label="用户2">
        <el-input placeholder="输入用户id" v-model.number="filter.receiverId"></el-input>
      </el-form-item>
      <el-form-item label="关联id">
        <el-input placeholder="输入职位id或服务id" v-model="filter.entityId"></el-input>
      </el-form-item>
      <el-form-item label="会话ID">
        <el-input placeholder="输入会话ID" v-model="filter.id"></el-input>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker v-model="filter.startTime" type="datetime" placeholder="开始时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="filter.endTime" type="datetime" placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
               <!--    <el-form-item label="消息内容">
                <el-input placeholder="输入消息内容" v-model="filter.content"></el-input>
            </el-form-item> -->
      <el-form-item>
        <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
        <el-button type="primary" size="mini" @click="rest">重置</el-button>

        <!-- <el-button type="primary" size="mini" @click="exportExcel">导出</el-button> -->
      </el-form-item>
    </el-form>

    <el-table :data="list" size="mini" v-loading="loading">
      <!-- <el-table-column prop="sender" label="发信方id"></el-table-column>
            <el-table-column prop="senderName" label="发信方昵称"></el-table-column>
            <el-table-column prop="senderRole" label="发信方角色">
                <template slot-scope="scope">{{scope.row.senderRole === 1 ? '甲方' : '乙方'}}</template>
</el-table-column>
<el-table-column prop="receiver" label="收信方id"></el-table-column>
<el-table-column prop="receiverName" label="收信方昵称"></el-table-column>
<el-table-column prop="receiverRole" label="收信方角色">
  <template slot-scope="scope">{{scope.row.receiverRole === 1 ? '甲方' : '乙方'}}</template>
</el-table-column>
<el-table-column prop="bodies" label="消息内容" width="500">
  <template slot-scope="scope">
                    <template>{{JSON.stringify(scope.row.bodies)}}</template>
  </template>
</el-table-column>
<el-table-column prop="createTime" label="沟通时间"></el-table-column> -->
      <el-table-column prop="id" label="会话ID"></el-table-column>
      <el-table-column prop="partyA" label="甲方id"></el-table-column>
      <el-table-column prop="partyAName" label="甲方昵称"></el-table-column>
      <el-table-column prop="partyB" label="乙方id"></el-table-column>
      <el-table-column prop="partyBName" label="乙方昵称"></el-table-column>
      <el-table-column prop="jobTitle" label="职位名称"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="latestContactTime" label="最后沟通时间"></el-table-column>
      <el-table-column prop="msgNum" label="消息总数"></el-table-column>
      <el-table-column prop="" label="操作">
        <template slot-scope="scope">
          <!-- <a :href="`/msgs?sessionId=${scope.row.id}?`" target="_blank"
            >查看详情</a
          > -->
          <span class="btn-text" @click="handleMsgs(scope.row)">
            查看详情
          </span>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination background layout="prev, pager, next" :current-page="pageNum"
        @current-change="(i) => (pageNum = i)" :page-size="limit" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../datamap";

import api from "../api";
let { user } = api;
export default {
  name: "sessions",
  data() {
    return {
      map,
      filter: {
        id:"",
        senderId: "",
        receiverId: "",
        entityId: "",
        startTime: '',
        endTime: '',
        // content: '',
      },
      loading: true,
      list: [],
      total: 0,
      pageNum: 1,
      limit: 100,
    };
  },
  computed: {
    senderId() {
      return this.$route.query.senderId;
    },
    receiverId() {
      return this.$route.query.receiverId;
    },
    entityId() {
      return this.$route.query.entityId;
    },
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  created() {
    if (this.id) this.filter.id = Number(this.id);
    if (this.senderId) this.filter.senderId = Number(this.senderId);
    if (this.receiverId) this.filter.receiverId = Number(this.receiverId);
    if (this.entityId) this.filter.entityId = this.entityId;
  },
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }

      let {
        id,
        senderId,
        receiverId,
        entityId,
        startTime,
        endTime,
        // content,
      } = this.filter;
      this.loading = true;
      let {
        data: { data, code, desc, pageinfo },
      } = await user.sessions({
        pageNum: this.pageNum,
        limit: this.limit,
        id,
        senderId: Number.isInteger(senderId) ? senderId : "",
        receiverId: Number.isInteger(receiverId) ? receiverId : "",
        receiverId,
        entityId,
        startTime,
        endTime
        // createTimeStart,
        // createTimeEnd,
        // content,
      });
      if (code == 200) {
        this.list = data;
        this.total = pageinfo.totalCount;
      }
      this.loading = false;
    },
    handleMsgs(row) {
      const url = this.$router.resolve({
        path: "/msgs",
        query: {
          sessionId: row.id,
          partyA: "",
          partyB: "",
        },
      }).href;
      window.open(url, "_blank");
    },
    rest() {
      this.filter = {
        quotationId: "",
        type: 0,
        jobId: '',
        partyA: '',
        chargingWay: '',
      }

      this.fetch();
    },
    // async exportExcel() {

    //     let {
    //         senderId,
    //         receiverId,
    //         createTimeStart,
    //         createTimeEnd,
    //         content,
    //     } = this.filter;

    //     this.loading = true;

    //     let resp = await user.exportMsgs({
    //         senderId,
    //         receiverId,
    //         createTimeStart,
    //         createTimeEnd,
    //         content,
    //     })
    //     let objectUrl = URL.createObjectURL(new Blob([resp.data]))
    //     let link = document.createElement('a')
    //     link.download = decodeURIComponent('沟通记录表.xlsx')
    //     link.href = objectUrl
    //     link.click()
    //     this.loading = false
    // },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style scoped>
.btn-text {
  color: #1ab394;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/user/sessions.vue